<template>
  <div class="c-app">
    <TheSidebar />
    <CWrapper>
      <TheHeader />
      <!-- Modal for loading and response -->
      <div v-if="isModalFormOpen" class="modal-overlay">
        <div class="submitting-form-modal-content">
          <span class="close" @click="closeModal">&times;</span>
          <!-- Show submitting form -->
          <div v-if="isSubmittingForm" class="loading-container">
            <CSpinner size="md" color="primary" />
          </div>
          <div v-else-if="createCustomerrrorMessage">
            <p class="error-message">{{ createCustomerrrorMessage }}</p>
          </div>
          <div v-else>
            <p style="font-size: 18px;">Staff Created Successfully!</p>
          </div>
        </div>
      </div>

      <div class="card">
        <CCardBody>
          <CRow>
            <CCol sm="10" md="8" class="mt-3" style="margin: auto">
              <h3>Create New Staff</h3>
              <CForm @submit.prevent="createStaff">
                <!-- name -->
                <CRow>
                  <CCol>
                    <CInput
                      v-model="create.first_name"
                      label="First name"
                      placeholder="Enter your first name"
                      required
                    >
                    </CInput>
                  </CCol>
                  <CCol>
                    <CInput
                      v-model="create.last_name"
                      label="Last name"
                      placeholder="Enter your last name"
                      required
                    >
                    </CInput>
                  </CCol>
                </CRow>
                <!-- email -->
                <CRow>
                  <CCol>
                    <CInput
                      v-model="create.email"
                      label="Email"
                      placeholder="Enter your email"
                      required
                    >
                    </CInput>
                  </CCol>
                  <!-- mobile -->
                  <CCol>
                    <CInput
                      v-model="create.mobile_no"
                      label="Mobile number"
                      placeholder="Enter your mobile number"
                      required
                    >
                    </CInput>
                  </CCol>
                </CRow>

                <!-- role -->
                <CRow>
                  <CCol>
                    <CSelect
                      v-model="create.role"
                      label="Role"
                      :options="roleOptions"
                      required
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol>
                    <CInput
                      v-model="create.password"
                      type="text"
                      label="New Password"
                      placeholder="New Password"
                    />
                  </CCol>
                  <CCol>
                    <CInput
                      v-model="create.confirm_password"
                      type="text"
                      label="Confirm Password"
                      placeholder="Confirm Password"
                      required
                    />
                  </CCol>
                </CRow>
                <CButton
                  color="primary"
                  type="submit"
                  :disabled="isSubmittingForm"
                  >Submit
                </CButton>
              </CForm>
            </CCol>
          </CRow>
        </CCardBody>
      </div>
    </CWrapper>
  </div>
</template>
<style>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.submitting-form-modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  position: relative;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
}

.error-message {
  color: red;
  font-weight: bold;
  margin-top: 20px;
  font-size: 18px;
}

.modal-content h3 {
  margin-bottom: 10px;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
  font-weight: bold;
  height: 100px;
}

.input-container {
  display: flex;
  flex-direction: column;
  padding: 10px;
  border-radius: 4px;
}

.input-label {
  margin-bottom: 5px;
}

.styled-input {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
  font-size: 16px;
}
</style>
<script>
import axios from "axios";
import { ref } from "vue";
import TheSidebar from "../../containers/TheSidebar.vue";
import TheHeader from "../../containers/TheHeader.vue";
import TheHeaderDropdownAccnt from "../../containers/TheHeaderDropdownAccnt.vue";
import TheFooter from "../../containers/TheFooter.vue";
import apiUtils from "../../utils/apiUtils";
import { CRow } from "@coreui/vue";

export default {
  name: "boCreateCustomer",
  components: {
    TheSidebar,
    TheHeader,
    TheHeaderDropdownAccnt,
    TheFooter,
  },
  data() {
    return {
      isStatementChecking: false,
      createCustomerrrorMessage: "",
      isSubmittingForm: false,
      isModalFormOpen: false,
      create: {
        first_name: "",
        last_name: "",
        mobile_no: "",
        password: "",
        email: "",
        is_staff: true,
        role: "",
      },
      roleOptions: [
        { value: "", label: "" },
        { value: "Financial", label: "Financial officer" },
        { value: 4, label: "Business officer" },
        { value: 1, label: "Administrator" },
      ],
    };
  },
  methods: {
    closeModal() {
      this.createCustomerrrorMessage = "";
      this.isSubmittingForm = false;
      this.isModalFormOpen = false;
    },

    async createStaff() {
      console.log("runned");
      const formData = new FormData();

      const payload = {
        first_name: this.create.first_name,
        last_name: this.create.last_name,
        mobile_no: this.create.mobile_no,
        password: this.create.password,
        email: this.create.email,
        is_staff: true,
        role: this.create.role,
      };
      console.log(payload);
      try {
        this.isModalFormOpen = true;
        this.isSubmittingForm = true;
        this.createCustomerrrorMessage = "";
        if (this.create.password != this.create.confirm_password) {
          this.createCustomerrrorMessage = "Password did not match!";
          return;
        }
        const response = await apiUtils.postRequest("/auth/users/", payload);
        console.log(response);
        // window.alert("Agent Created Successfully!");
      } catch (error) {
        console.log("There was an error:", error.response.data);
        if (error.response.data) {
          this.createCustomerrrorMessage = Object.keys(error.response.data)
            .map((key) => `${key}: ${error.response.data[key]}`)
            .join("\n");
        } else {
          this.createCustomerrrorMessage = "Agent Could Not Be Created!";
        }
        // window.alert("Agent Could Not Be Created!");
      } finally {
        this.isSubmittingForm = false;
      }
    },
  },
  setup() {
    const createBorrower = async () => {
      await this.createBorrower(); // Call the component's createBorrower method
    };
    null;

    return {
      createBorrower,
    };
  },
};
</script>
